import {
  FloorOccupancyValidationResponse,
  FloorWorkstationRequest,
  StaleMapRevisionResponse,
} from "../../api/generated";
import { FloorMapSaveRejection } from "../../types/FloorTypes";

export type FloorMapSaveFailure = { kind: "stale" } | { kind: "message"; message: string } | { kind: "other" };

export const describeFloorMapSaveFailure = (
  rejection: FloorMapSaveRejection,
  workstations: FloorWorkstationRequest[],
): FloorMapSaveFailure => {
  const body = rejection?.data as FloorOccupancyValidationResponse | StaleMapRevisionResponse | string | undefined;

  if (rejection?.status === 409 && typeof body === "object" && body?.error === "STALE_MAP_REVISION") {
    return { kind: "stale" };
  }
  if (rejection?.status !== 400) return { kind: "other" };

  if (typeof body === "string" && body) return { kind: "message", message: body };
  if (typeof body === "object" && "failures" in body && body.failures?.length) {
    const lines = body.failures.map((failure) => `${labelOf(failure.workstationId, workstations)}: ${failure.message}`);
    return { kind: "message", message: ["The floor was not saved:", ...lines].join("\n") };
  }
  return { kind: "other" };
};

const labelOf = (workstationId: string | undefined, workstations: FloorWorkstationRequest[]) =>
  workstations.find((workstation) => workstation.id === workstationId)?.occupancy?.svgDisplayName ?? workstationId;
